<template>
	<div class="modal" id="cancelTrade" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm modal-dialog-centered" role="document">
			<form class="modal-content" @submit.prevent="cancelTrade">
				<div class="modal-header">
					<h5 class="modal-title">Cancel Trade</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<p class="mg-b-0">Do you really want to cancel this trade?</p>
				</div>
				<div class="modal-footer">
					<div class="wd-100p d-flex">
						<button-component :busy="form.busy" :label="'Yes, Cancel'" :label-loading="'Please wait...'" :button-class="'btn btn-danger shadow-sm flex-fill'"></button-component>
						<button type="button" data-dismiss="modal" class="btn btn-primary shadow-sm flex-fill mg-l-10">Close</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	mounted() {
		$('#cancelTrade').on('show.bs.modal', (event) => {
			const history = $(event.relatedTarget);
			const trade = history.data('trade');

			this.trade = trade;
		});

		$('#cancelTrade').on('hidden.bs.modal', (e) => {
			this.trade = null;
		});
	},
	data() {
		return {
			form: new Form({
				status: 'cancelled',
				execution_status: 'cancelled',
			}),
		};
	},
	methods: {
		cancelTrade() {
			let url = `/api/trade/${this.trade}`;

			this.form.patch(url).then(() => {
				$('#cancelTrade').modal('hide');

				this.refresh = true;
			});
		},
	},
};
</script>

<style>
</style>